<template>
  <div class="pinch-in-card" v-show="showPinchIn">
    <div class="modal-inner flexcenter">
      <div class="pinch-type card-voice">
        <button class="modal-close" @click="clickClose"></button>
        <div class="pinch-inInner">
          <div class="item">
            <div class="flexbox" v-if="pinchInAct != null">
              <!--<button class="icon-pinch-close"></button>-->
                <div class="select">
                  <template v-if="pinchTileText != null">
                    <span v-show="pinchInShowAnswerText" :class="getPinchInTextFontclassAct(pinchTileText.answerText, $parent.productLanguage)" v-html="pinchTileText.answerText"/>
                    <span v-show="!pinchInShowAnswerText" :class="getPinchInTextFontclassAct(pinchTileText.answerText, $parent.productLanguage)" v-html="pinchTileText.questionText"/>
                  </template>
                  <template v-else>
                    <span v-show="pinchInShowTextAct" :class="getPinchInTextFontclassAct(pinchInDispText, $parent.productLanguage)" v-html="pinchInDispText" />
                  </template>
                </div>
                <div class="card">
                  <div v-show="!horizontalRow" class="image">
                    <img :src="pinchInAct.image">
                    <p v-if="pinchImageText" :class="pinchImageTextFontClass">
                      {{ pinchImageText }}
                    </p>
                  </div>
                  <div v-if="horizontalRow && checkIsComplete()" class="image">
                    <img :src="pinchInAct.image">
                    <p v-if="pinchImageText" :class="pinchImageTextFontClass">
                      {{ pinchImageText }}
                    </p>
                  </div>
                  <div v-else-if="horizontalRow" class="image">
                    <img src="/static/images/blank.jpg">
                  </div>
                  <button v-show="pinchInShowVoice" class="icon-voice" @click="pinchinActAudioPlay()"></button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import * as constants from "@/store/constants";

export default {
  name: "PinchInActStore",
  mixins: [
    common,
    runmode
  ],
  data() {
    return {
      // 表示ACT
      pinchInAct: null,
      /**
       * Tile用テキストObject
       * {
       *   answerText: String,
       *   questionText: String
       * }
       */
      pinchTileText: null,
      // 回答表示フラグ
      pinchInShowAnswerText: false,
      // 音声再生可能フラグ
      pinchInShowVoice: false,
      // テキスト表示フラグ
      pinchInShowTextAct: false,
      // 画像表示
      horizontalRow: false,
      // 表示テキスト
      pinchInDispText: "",
      // ACTのindex
      pinchInActIndex: 0,
      // 全回答済
      isCompletes: [],
      // 画像用テキスト
      pinchImageText: null,
      // 画像用テキストフォントクラス
      pinchImageTextFontClass: null
    };
  },
  computed: {
    pinchInParams: function() {
      return this.$store.getters.pinchInParams;
    },
    showPinchIn: function() {
      return this.$store.getters.showPinchIn;
    }
  },
  methods: {
    /**
     * 閉じるボタン押下時の処理
     */
    clickClose: function() {
      this.log("PinchInAct start clickClose");

      // 閉じる
      this.$store.dispatch("hidePinchIn");
    },
    pinchinActAudioPlay: function() {
      this.log("PinchInAct start pinchinActAudioPlay:" + this.pinchInActIndex);
      this.$store.dispatch("setPinchInAudioPlayActIndex", this.pinchInActIndex);
    },
    checkIsComplete: function() {
      if (this.isCompletes[this.pinchInActIndex]) {
        return true;
      } else {
        return false;
      }
    },
    resetParams: function() {
      this.pinchInAct = null;
      this.pinchTileText = null;
      this.pinchInShowAnswerText = false;
      this.pinchInShowVoice = false;
      this.horizontalRow = false;
      this.pinchInShowTextAct = false;
      this.pinchInDispText = "";
      this.pinchInActIndex = 0;
      this.isCompletes = [];
      this.pinchImageText = null;
      this.pinchImageTextFontClass = null;
    },
    setParams: function(pinchInActParams) {
      // パラメータセット
      if (pinchInActParams.pinchInAct) this.pinchInAct = pinchInActParams.pinchInAct;
      if (pinchInActParams.pinchTileText) this.pinchTileText = pinchInActParams.pinchTileText;
      if (pinchInActParams.pinchInShowAnswerText) this.pinchInShowAnswerText = pinchInActParams.pinchInShowAnswerText;
      if (pinchInActParams.pinchInShowVoice) this.pinchInShowVoice = pinchInActParams.pinchInShowVoice;
      if (pinchInActParams.pinchInShowTextAct) this.pinchInShowTextAct = pinchInActParams.pinchInShowTextAct;
      if (pinchInActParams.pinchInDispText) this.pinchInDispText = pinchInActParams.pinchInDispText;
      if (pinchInActParams.pinchInActIndex) this.pinchInActIndex = pinchInActParams.pinchInActIndex;
      if (pinchInActParams.isCompletes) this.isCompletes = pinchInActParams.isCompletes;
      if (pinchInActParams.horizontalRow) this.horizontalRow = pinchInActParams.horizontalRow;
      if (pinchInActParams.pinchImageText) this.pinchImageText = pinchInActParams.pinchImageText;
      if (pinchInActParams.pinchImageTextFontClass) this.pinchImageTextFontClass = pinchInActParams.pinchImageTextFontClass;
    }
  },
  created() {},
  mounted: function() {},
  updated: function() {},
  watch: {
    /**
     * 表示パラメータ更新
     * @param Object newPinchInParams
     */
    pinchInParams: function(newPinchInParams) {
      this.resetParams();
      this.setParams(newPinchInParams);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// PinchInActStore.vue?14c8719e